import type { Cs2CatalogCategory, Cs2CatalogItem } from '@redd/contracts';

export type MarketCategory = '全部' | Cs2CatalogCategory;
export type MarketCatalogItem = {
  id: string;
  marketHashName: string;
  category: Cs2CatalogCategory;
  name: string;
  wear: string;
  priceFen: number;
  listings: number;
  image: string;
  rarity: string;
};

export function normalizeMarketCatalog(items: Cs2CatalogItem[]): MarketCatalogItem[] {
  return items.map((item) => {
    return {
      id: item.id,
      marketHashName: item.marketHashName,
      category: item.category,
      name: item.displayName,
      wear: item.wear,
      priceFen: item.priceCny === undefined ? 0 : Math.round(item.priceCny * 100),
      listings: item.listings ?? 0,
      image: item.imageUrl,
      rarity: item.rarity,
    };
  });
}

export const formatPrice = (priceFen: number) => `${priceFen < 0 ? '-' : ''}¥${(Math.abs(priceFen) / 100).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
